import { render, staticRenderFns } from "./OsdReport.vue?vue&type=template&id=51cf015e"
import script from "./OsdReport.vue?vue&type=script&lang=js"
export * from "./OsdReport.vue?vue&type=script&lang=js"
import style0 from "./OsdReport.vue?vue&type=style&index=0&id=51cf015e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports